import { createUseStyles } from "react-jss";

export const GLOBAL_STYLES = {
  "@global": {
    "*": {
      boxSizing: "border-box",
      padding: 0,
      margin: 0,
      fontDisplay: "swap"
    },
    body: {
      fontFamily: "Montserrat, Sans Serif, Ubuntu, Droid Sans, Roboto, San Francisco !important",
      fontSize: 16,
      lineHeight: 1.5,
      fontWeight: 400,
      color: "#2D2442",
      "& h1, .h1": {
        fontSize: 40,
        lineHeight: 1.4,
        fontWeight: 700,
        "@media (max-width: 600px)": {
          fontSize: 28
        }
      },
      "& h2, .h2": {
        fontSize: 28,
        lineHeight: 1.4,
        fontWeight: 700,
        "@media (max-width: 600px)": {
          fontSize: 20,
          lineHeight: 1.3
        }
      },
      "& h3, .h3": {
        fontSize: 24,
        lineHeight: 1.5,
        fontWeight: 700,
        "@media (max-width: 600px)": {
          fontSize: 20,
          lineHeight: 1.6
        }
      },
      "& h4, .h4": {
        fontSize: 20,
        lineHeight: 1.6,
        fontWeight: 500,
        "@media (max-width: 600px)": {
          fontSize: 16,
          lineHeight: 1.6
        }
      },
      "& h5, .h5": {
        fontSize: 18,
        lineHeight: 1.5,
        fontWeight: 600,
        "@media (max-width: 600px)": {
          fontSize: 16,
          fontWeight: 700,
          "&.regular": {
            fontWeight: 600
          }
        }
      },
      "& h6, .h6": {
        fontSize: 16,
        lineHeight: 1.5,
        fontWeight: 500
      },
      // Links
      "& a": {
        textDecoration: "none",
        "&:hover, &:focus": {
          textDecoration: "none",
        },
        "&.underline": {
          textDecoration: "underline",
          textDecorationColor: "#FFFFFF",
          "&:hover, &:focus": {
            textDecoration: "underline",
            color: "#FFFFFF"
          }
        }
      },
      // Header
      "& .header": {
        position: "relative",
        "&:after": {
          content: "''",
          display: "block",
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "linear-gradient(180deg, #3A28A7 -56.81%, #6049EB 100%), linear-gradient(180deg, rgba(96, 73, 235, 0.1) 0%, rgba(96, 73, 235, 0.05) 83.7%, rgba(96, 73, 235, 0) 100%)",
          opacity: 0.8
        }
      },
      //Gatsby img
      "& .gatsby-image-wrapper": {
        width: "100%",
        "& > div": {
          "@media (max-width: 1200px)": {
            maxWidth: "100% !important"
          }
        },
        "& img": {
          "@media (max-width: 1200px)": {
            maxWidth: "100% !important"
          }
        }
      },
      // Carousel
      "& .carousel-wrapper": {
        marginLeft: -12,
        marginRight: -12,
        "@media (max-width: 1200px)": {
          marginLeft: -8,
          marginRight: -8
        },
        "@media (max-width: 600px)": {
          marginLeft: -4,
          marginRight: -4
        },
        "& .react-multi-carousel-list": {
          "& .react-multi-carousel-track": {
            margin: "auto",
            alignItems: "center",
            // minWidth: 1024,
            // "@media (max-width: 1200px)": {
            //   minWidth: "unset"
            // },
            "& .carousel-item": {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 12,
              paddingRight: 12,
              width: "100%",
              maxHeight: 80,
              "& img": {
                maxHeight: 80
              },
              "@media (max-width: 1200px)": {
                paddingLeft: 8,
                paddingRight: 8,
                // "& img": {
                //   maxHeight: 64
                // }
              },
              "@media (max-width: 600px)": {
                paddingLeft: 4,
                paddingRight: 4,
                "& img": {
                  // maxHeight: 56
                  width: "100%"
                }
              }
            }
          }
        },
      },
      //Global container
      "& .container": {
        maxWidth: 1224,
        marginLeft: "auto",
        marginRight: "auto",
        width: "100%",
        padding: "0 24px",
        overflow: "hidden",
        "@media (max-width: 1200px)": {
          maxWidth: "992px",
          padding: "0 32px"
        },
        "@media (max-width: 600px)": {
          maxWidth: "100%",
          padding: "0 16px"
        }
      },
      //Modals
      "& .ReactModal__Overlay": {
        zIndex: 99999999999,
        backgroundColor: "rgba(0, 0, 0, 0.4) !important",
        overflow: "hidden",
        "&:not(.simple-rounded)": {
          "& .ReactModal__Content" : {
            borderRadius: "8px !important",
            "@media (max-width: 600px)": {
              borderRadius: "0 !important"
            }
          }
        },
        "& .ReactModal__Content": {
          border: "none !important",
          borderRadius: "16px !important",
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
          outline: "none !important"
        },
        "& .modalCloseBtn": {
          width: 28,
          height: 28,
          backgroundColor: "transparent",
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.6921 6.30749C22.1025 6.71748 22.1025 7.3822 21.6921 7.79219L15.4853 13.9999L21.6923 20.2078C22.1027 20.6178 22.1027 21.2825 21.6923 21.6925C21.2819 22.1025 20.6166 22.1025 20.2062 21.6925L14 15.4854L7.79385 21.6925C7.38348 22.1025 6.71814 22.1025 6.30778 21.6925C5.89741 21.2825 5.89741 20.6178 6.30778 20.2078L12.5148 13.9999L6.30793 7.79219C5.89756 7.3822 5.89756 6.71748 6.30793 6.30749C6.7183 5.8975 7.38363 5.8975 7.794 6.30749L14 12.5144L20.2061 6.30749C20.6164 5.8975 21.2818 5.8975 21.6921 6.30749Z' fill='%23A9ADB5'/%3E%3C/svg%3E%0A\")",
          backgroundPosition: "center",
          border: "none",
          cursor: "pointer",
          position: "absolute",
          top: 12,
          right: 12
        }
      },
      "&.ReactModal__Body--open": {
        overflow: "hidden"
      },
      "&.modalWhiteBg": {
        overflow: "hidden",
        "& .ReactModal__Overlay": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& .ReactModal__Content": {
            backgroundColor: "#FFFFFF",
            maxWidth: 700,
            width: "100%",
            position: "relative",
            margin: 48,
            "@media (max-width: 600px)": {
              margin: "0 !important",
              top: "0 !important",
              right: "0 !important",
              left: "0 !important",
              bottom: "0 !important",
              position: "fixed !important",
              borderRadius: "0 !important",
              paddingLeft: 16,
              paddingRight: 16,
              paddingBottom: 100,
              overflowY: "auto"
            }
          }
        }
      },
      "&.modalForm": {
        "& .ReactModal__Overlay": {
          "& .ReactModal__Content": {
            maxWidth: "560px !important",
            maxHeight: "95vh",
            inset: "unset !important",
            padding: "48px 82px !important",
            "@media (max-width: 600px)": {
              padding: "32px 24px !important",
              maxHeight: "100%",
              maxWidth: "100% !important"
            }
          }
        },
      },
      //Forms
      "& form": {
        "&.formWasSend": {
          "& > *:not(.formMessage.Success)": {
            display: "none !important"
          }
        },
        "& .formControl": {
          position: 'relative',
          "& + .formControl": {
            marginTop: 24
          }
        },
        "& .formControlError": {
          "& label": {
            color: "#FB3D39"
          },
          "& input, textarea": {
            borderColor: "#FB3D39",
            "&::placeholder": {
              color: "#FB3D39"
            }
          }
        },
        "& .formErrorMessage": {
          fontSize: 12,
          color: "#FB3D39",
          marginTop: 4,
          display: "block"
        },
        "& .formTextAreaContainer": {
          position: "relative"
        },
        "& .formTextAreaCounter": {
          color: "#878D9A",
          fontSize: 14,
          fontWeight: 500
        },
        "& label": {
          display: "block",
          fontSize: 14,
          lineHeight: 1.5,
          fontWeight: 500,
          textAlign: "left",
          "&.label-flex": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          },
          "& .required-star": {
            color: "#EE426A"
          }
        },
        "& .formControlBrandingError": {
          "& input": {
            borderColor: "#FB3D39",
            boxShadow: '0 0 0 4px rgba(238,66,106,.2)'
          },
          '& input:not([type=date])': {
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 14.25C11.3787 14.25 10.875 14.7537 10.875 15.375C10.875 15.9963 11.3787 16.5 12 16.5C12.6213 16.5 13.125 15.9963 13.125 15.375C13.125 14.7537 12.6213 14.25 12 14.25ZM12 7.5C11.3787 7.5 10.875 8.00368 10.875 8.625V12C10.875 12.6213 11.3787 13.125 12 13.125C12.6213 13.125 13.125 12.6213 13.125 12V8.625C13.125 8.00368 12.6213 7.5 12 7.5Z\' fill=\'%23EE426A\'/%3E%3C/svg%3E%0A")',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '1.5rem',
            backgroundPosition: 'center right 1rem',
            paddingRight: '3.5rem'
          },
          '& input[type=date]': {
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M9.5463 3C9.5463 2.44772 9.09858 2 8.5463 2C7.99401 2 7.5463 2.44772 7.5463 3V4H4.99968C3.89511 4 2.99968 4.89543 2.99968 6V20C2.99968 21.1046 3.89511 22 4.99968 22H18.9997C20.1042 22 20.9997 21.1046 20.9997 20V9.03155C21 9.02108 21.0002 9.01056 21.0002 9C21.0002 8.98945 21 8.97893 20.9997 8.96845V6C20.9997 4.89543 20.1042 4 18.9997 4H16.8201V3C16.8201 2.44772 16.3724 2 15.8201 2C15.2679 2 14.8201 2.44772 14.8201 3V4H9.5463V3ZM7.58381 6C7.70237 6.41997 8.08839 6.72774 8.5463 6.72774C9.0042 6.72774 9.39023 6.41997 9.50879 6H14.8576C14.9762 6.41997 15.3622 6.72774 15.8201 6.72774C16.278 6.72774 16.6641 6.41997 16.7826 6H18.9997V8L5.00017 8C5.00001 8 4.99984 8 4.99968 8V6H7.58381ZM4.99968 10V20H18.9997V10L5.00017 10C5.00001 10 4.99984 10 4.99968 10Z\' fill=\'%23EE426A\'/%3E%3C/svg%3E%0A")'
          }
        },
        "& .formControlBrandingSuccess": {
          "& input": {
            boxShadow: '0 0 0 4px rgba(151,222,107,.2)',
            borderColor: '#65c15d'
          },
          '& input:not([type=date])': {
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6 11L10.4274 15.9194C10.4665 15.9628 10.5344 15.9636 10.5745 15.9211L19 7\' stroke=\'%2365C15D\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E%0A")',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '1.5rem',
            backgroundPosition: 'center right 1rem',
            paddingRight: '3.5rem'
          },
          '& input[type=date]': {
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'24\' height=\'24\' viewBox=\'0 0 24 24\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M9.5463 3C9.5463 2.44772 9.09858 2 8.5463 2C7.99401 2 7.5463 2.44772 7.5463 3V4H4.99968C3.89511 4 2.99968 4.89543 2.99968 6V20C2.99968 21.1046 3.89511 22 4.99968 22H18.9997C20.1042 22 20.9997 21.1046 20.9997 20V9.03155C21 9.02108 21.0002 9.01056 21.0002 9C21.0002 8.98945 21 8.97893 20.9997 8.96845V6C20.9997 4.89543 20.1042 4 18.9997 4H16.8201V3C16.8201 2.44772 16.3724 2 15.8201 2C15.2679 2 14.8201 2.44772 14.8201 3V4H9.5463V3ZM7.58381 6C7.70237 6.41997 8.08839 6.72774 8.5463 6.72774C9.0042 6.72774 9.39023 6.41997 9.50879 6H14.8576C14.9762 6.41997 15.3622 6.72774 15.8201 6.72774C16.278 6.72774 16.6641 6.41997 16.7826 6H18.9997V8L5.00017 8C5.00001 8 4.99984 8 4.99968 8V6H7.58381ZM4.99968 10V20H18.9997V10L5.00017 10C5.00001 10 4.99984 10 4.99968 10Z\' fill=\'%2365C15D\'/%3E%3C/svg%3E%0A")'
          }
        },
        '& .formControlBrandingErrorMessage': {
          position: 'absolute',
          left: '50%',
          bottom: 'calc(100% - .25rem)',
          transform: 'translateX(-50%)',
          backgroundColor: '#ee426a',
          color: '#fff',
          fontSize: '.75rem',
          lineHeight: '1.5',
          fontWeight: '500',
          padding: '1rem',
          borderRadius: '.5rem',
          filter: 'drop-shadow(0 0 8px rgba(0,0,0,.08)) drop-shadow(0 16px 16px rgba(0,0,0,.08))',
          width: 'max-content',
          maxWidth: '100%',
          textAlign: 'center',
          '&:after': {
            content: '\'\'',
            width: '1.4375rem',
            height: '.6875rem',
            backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'23\' height=\'10\' viewBox=\'0 0 23 10\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M14.2649 8.35532C12.7184 9.83456 10.2816 9.83457 8.73511 8.35532L9.45698e-07 1.03375e-07L23 -1.90735e-06L14.2649 8.35532Z\' fill=\'%23EE426A\'/%3E%3C/svg%3E%0A")',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: '-.625rem'
          }
        },
        "& input, textarea, select": {
          marginTop: 8,
          border: "1px solid #C3C6CD",
          borderRadius: 8,
          paddingTop: 13.8,
          paddingRight: 16,
          paddingBottom: 13.8,
          paddingLeft: 16,
          fontSize: 16,
          fontWeight: 500,
          outline: "none",
          letterSpacing: 0.15,
          width: "100%",
          fontFamily: "Montserrat, Sans Serif, Ubuntu, Droid Sans, Roboto, San Francisco !important",
          transaction: "all .5s",
          "&::placeholder": {
            color: "#878D9A"
          },
          "&:focus": {
            boxShadow: "0px 0px 0px 4px rgb(119 112 255 / 20%)",
            borderColor: "#6049EB"
          }
        },
        '& input[type=date]': {
            '-webkit-appearance': 'none',
            '-moz-appearance': 'textfield',
            height: '50px',
            color: '#878D9A',
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.5463 3C9.5463 2.44772 9.09858 2 8.5463 2C7.99401 2 7.5463 2.44772 7.5463 3V4H4.99968C3.89511 4 2.99968 4.89543 2.99968 6V20C2.99968 21.1046 3.89511 22 4.99968 22H18.9997C20.1042 22 20.9997 21.1046 20.9997 20V9.03155C21 9.02108 21.0002 9.01056 21.0002 9C21.0002 8.98945 21 8.97893 20.9997 8.96845V6C20.9997 4.89543 20.1042 4 18.9997 4H16.8201V3C16.8201 2.44772 16.3724 2 15.8201 2C15.2679 2 14.8201 2.44772 14.8201 3V4H9.5463V3ZM7.58381 6C7.70237 6.41997 8.08839 6.72774 8.5463 6.72774C9.0042 6.72774 9.39023 6.41997 9.50879 6H14.8576C14.9762 6.41997 15.3622 6.72774 15.8201 6.72774C16.278 6.72774 16.6641 6.41997 16.7826 6H18.9997V8L5.00017 8C5.00001 8 4.99984 8 4.99968 8V6H7.58381ZM4.99968 10V20H18.9997V10L5.00017 10C5.00001 10 4.99984 10 4.99968 10Z' fill='%236049EB'/%3E%3C/svg%3E%0A")`,
            backgroundPosition: 'center right 16px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '24px',
            textTransform: 'uppercase',

            '&:focus': {
                color: '#333333'
            },

            '&::-webkit-calendar-picker-indicator': {
                opacity: 0
            }
        },
        "& select": {
          '-webkit-appearance': 'none',
          '-moz-appearance': 'none',
          textIndent: '1px',
          textOverflow: '',
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.1146 9.6001C9.22369 9.6001 8.77752 10.6772 9.40749 11.3072L11.9933 13.893C12.3838 14.2835 13.017 14.2835 13.4075 13.893L15.9933 11.3072C16.6232 10.6772 16.1771 9.6001 15.2862 9.6001H10.1146Z' fill='%236049EB'/%3E%3C/svg%3E%0A")`,
          backgroundPosition: 'center right 12px',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '24px',
          paddingRight: '36px',
          color: '#333333',
          lineHeight: 'normal',
        },
        '& .formAgreements': {
          marginTop: '32px',
          '& .formAgreementsContainer': {
            position: 'relative',

            '& ~ *': {
                marginTop: '32px',
            },

            '& + .formAgreementsContainer': {
              marginTop: 24
            },

            '& > label': {
              fontSize: '14px',
              lineHeight: '1.4',
              fontWeight: '500',
              color: '#818699',
              paddingLeft: '29px',
              position: 'relative',
              margin: 0,

              '&:before': {
                  content: "''",
                  width: '18px',
                  height: '18px',
                  border: '2px solid #C3C6CD',
                  borderRadius: '1px',
                  display: 'block',
                  position: 'absolute',
                  left: '0',
                  top: '3px',
                  boxSizing: 'border-box',
              },

              '& a': {
                  color: '#6049EB',
                  textDecoration: 'underline',
              }
            },

            '&.error': {
                '& > label': {
                    '&:before': {
                        boxShadow: '0px 0px 0px 4px rgba(238, 66, 106, 0.2)',
                        borderColor: '#EE426A',
                    }
                }
            },

            '&.valid': {
                '& > label': {
                    '&:before': {
                        boxShadow: '0px 0px 0px 4px rgba(151, 222, 107, 0.2)',
                        borderColor: '#65C15D',
                    }
                }
            },

            '& input': {
                visibility: 'hidden',
                position: 'absolute',
                top: '5px',
                left: '2.5px',

                '&:checked': {
                    '& + label': {
                        '&:before': {
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='10' viewBox='0 0 12 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.5 5L4.77273 8.375L10.5 1.625' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '10px 8px',
                            backgroundPosition: 'center',
                            backgroundColor: '#65C15D',
                            borderColor: '#65C15D',
                        }
                    }
                }
            }
          }
        },
        "& textarea": {
          resize: "none",
          minHeight: 96
        },
        "& .formActions": {
          marginTop: 32,
          display: "flex",
          justifyContent: "flex-end",
          "& a, button": {
            minWidth: 190
          }
        },
        '& .formActionsBranding': {
          marginTop: 32,
          display: "flex",
          justifyContent: "space-between",
          "& > * + *": {
            marginLeft: 24,
            "@media (max-width: 767px)": {
              marginLeft: 0
            }
          },
          "& a, button": {
            width: '50%'
          },
          "& button:first-of-type": {
            background: 'transparent',
            border: '1px solid #cbceda',
            color: '#2d2442',
            '&:hover': {
              backgroundColor: '#f2f3f5',
              borderColor: '#f2f3f5'
            }
          },
          "@media (max-width: 767px)": {
            marginTop: 0,
            flexDirection: 'column',
            overflow: 'auto',
            "& a, button": {
              minWidth: '100%',
              marginTop: '24px',
            },
          }
        },
        '& .formActionsContactUs': {
          marginTop: 32,
          display: "flex",
          justifyContent: "flex-end",
          "& > * + *": {
            marginLeft: 24,
            "@media (max-width: 767px)": {
              marginLeft: 0
            }
          },
          "& a, button": {
            width: '50%'
          },
          "@media (max-width: 767px)": {
            marginTop: 0,
            overflow: 'auto',
            flexDirection: 'column',
            "& a, button": {
              minWidth: '100%',
              marginTop: '24px',
            },
          }
        },
        "& .formMessage": {
          textAlign: "center",
          "& .formMessage-Icon": {
            width: 80,
            height: 80,
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: 24,
            "@media (max-width: 600px)": {
              width: 64,
              height: 64,
              marginBottom: 16
            },
            "& svg": {
              width: "100%",
              height: "100%"
            }
          },
          "& .formMessageDescription": {
            marginTop: 24,
            "@media (max-width: 600px)": {
              marginTop: 8
            }
          },
        }
      },
      "& .formHero": {
        textAlign: "center",
        marginBottom: 24,
        "&-Icon": {
          backgroundColor: "#F6F6F6",
          width: 100,
          height: 100,
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "auto",
          marginRight: "auto"
        },
        "&-Title": {
          marginTop: 32,
          fontSize: 28,
          fontWeight: 700
        }
      },
      // Quiz join block
      "& .JoinFormMain": {
        backgroundColor: "#6049EB",
        color: "#fff",
        paddingTop: 24,
        paddingBottom: 24,
        "@media (max-width: 1200px)": {
          display: "none"
        },
        "& .JoinForm": {
          overflow: "unset"
        },
        "& .JoinFormWrapper": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .JoinFormElements": {
            marginLeft: 24,
            // marginRight: 24,
            position: "relative"
          },
          "& .JoinFormElementsContainer": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& .Connect__CodeInput": {
              marginTop: 0,
              width: 150,
              borderTopLeftRadius: 86,
              borderBottomLeftRadius: 86,
              border: "2px solid rgba(255, 255, 255, 0.5)",
              backgroundColor: "transparent",
              letterSpacing: "0.04em",
              fontSize: 20,
              fontWeight: 600,
              lineHeight: "0.6",
              padding: 14,
              textAlign: "center",
              color: "#FFF !important",
              // "&.input-validation-error": {
              //   borderColor: "#FB3D39",
              //   color: "#FB3D39",
              //   "&::placeholder": {
              //     color: "#FB3D39"
              //   }
              // },
              "&:focus": {
                boxShadow: "none"
              },
              "&::placeholder": {
                color: "#ABA0F1",
                letterSpacing: "0.04em",
                fontSize: 20,
                fontWeight: 600,
              }
            },
            "& .btnHeader": {
              minWidth: 152,
              backgroundColor: "#65C15D",
              color: "#fff",
              borderTopRightRadius: 86,
              borderBottomRightRadius: 86,
              fontFamily: "Montserrat",
              fontSize: 15,
              fontWeight: 600,
              lineHeight: "0.5",
              padding: 23.25,
              marginLeft: -2,
              "&:hover, &:focus": {
                backgroundColor: "#97DE6B"
              },
            }
          },
          "& .HowToPlay": {
            display: "none",
            "& a": {
              textDecoration: "underline",
              cursor: "pointer"
            }
          },
          "& .Connect__ValidationMessage": {
            position: "absolute",
            zIndex: 1,
            top: "calc(100% + 15px)",
            "& li": {
              listStyle: "none",
              backgroundColor: "#EE426A",
              color: "#FFF",
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 500,
              padding: 16,
              "&:before": {
                content: "''",
                left: "50%",
                width: 16,
                height: 16,
                top: -7,
                display: "block",
                position: "absolute",
                transform: "translateX(-50%) rotate(-45deg)",
                backgroundColor: "#EE426A"
              }
            }
          }
        }
      }
    }
  },
  // Container
  container: {
    maxWidth: 1272,
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    padding: "0 24px",
    // overflow: "hidden",
    "@media (max-width: 1200px)": {
      maxWidth: "100%",
      padding: "0 32px"
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
      padding: "0 24px"
    }
  },
  containerPricing: {
    maxWidth: '1304px',
    width: '100%',
    paddingLeft: '40px',
    paddingRight: '40px',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    '@media screen and (max-width: 767px)': {
      paddingLeft: '20px',
      paddingRight: '20px'
    },
    '@media (min-width: 767px) and (max-width: 1199px)': {
      paddingLeft: '36px',
      paddingRight: '36px',
    }
  }
};
export const useGlobalStyles = createUseStyles(GLOBAL_STYLES);
